import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Alert, Col, Form, FormFeedback, FormGroup, Input, Label, PopoverBody, Row, UncontrolledPopover } from 'reactstrap';
import Select from "react-select";
import SingleUploadfile from '../../common/single-uploadfile';

const RequestFormPam = ({ dataFormPam, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const [formTemp, setFormTemp] = useState({});
    const [selectReqLegalTeamTo, setSelectReqLegalTeamTo] = useState(null);
    const [selectBU, setSelectBU] = useState(null);
    const [selectBuActAs, setSelectBuActAs] = useState(null);
    const [selectCounterpartyActAs, setSelectCounterpartyActAs] = useState(null);
    const [selectIsStampDuty, setSelectIsStampDuty] = useState(null);
    const [selectDepositType, setSelectDepositType] = useState(null);
    const [selectLanguage, setSelectLanguage] = useState(null);
    const [selectConfidential, setSelectConfidential] = useState(null);
    const [pcMultiDateType, setPcMultiDateType] = useState("");
    const [totalProductPriceType, setTotalProductPriceType] = useState("");
    const [paymentTermType, setPaymentTermType] = useState("");
    const [depositBondType, setDepositBondType] = useState("");
    const [sharePdpa, setSharePdpa] = useState("");
    const [fileReqLegalTeamToDoc, setFileReqLegalTeamToDoc] = useState([]);
    const [fileDetailProductDoc, setFileDetailProductDoc] = useState([]);
    const [fileSaleDetailDoc, setFileSaleDetailDoc] = useState([]);
    const [fileCounterpartyDoc, setFileCounterpartyDoc] = useState([]);
    const [ddlReqLegalTeamTo, setDdlReqLegalTeamTo] = useState([]);
    const [ddlBU, setDdlBU] = useState([]);
    const [ddlLanguage, setDdlLanguage] = useState([]);
    const [ddlConfidential, setDdlConfidential] = useState([]);
    const [ddlBuActAs, setDdlBuActAs] = useState([]);
    const [ddlCounterpartyActAs, setDdlCounterpartyActAs] = useState([]);
    const [ddlIsStampDuty, setDdlIsStampDuty] = useState([]);
    const [ddlDepositType, setDdlDepositType] = useState([]);
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: 0,
            id_request: 0,
            id_request_type: 0,
            id_sub_request_type: 0,
            id_sub_division_request_type: 0,
            project_name: "",
            req_legal_team_to: "",
            req_legal_team_to_doc: "",
            id_business_unit: "",
            business_unit_other: "",
            business_unit_act_as: "",
            counterparty_name: "",
            counterparty_doc: "",
            counterparty_act_as: "",
            purpose_sale: "",
            place_of_delivery: "",
            detail_product: "",
            detail_product_doc: "",
            sow_deliver: "",
            sale_detail_doc: "",
            term_start_date: "",
            term_end_date: "",
            practical_complete_date: "",
            pc_multi_date_type: "",
            pc_multi_date_detail: "",
            final_complete_date: "",
            final_complete_detail: "",
            product_price: "",
            installation_fee: "",
            total_product_price_type: "",
            total_product_price: "",
            is_stamp_duty: "",
            stamp_duty_price: "",
            payment_term_type: "",
            payment_term_desc_lump_sum: "",
            payment_term_desc_instalment: "",
            credit_term: "",
            deposit_type: "",
            deposit_detail: "",
            performance_bond: "",
            retention: "",
            return_of_retention: "",
            deposit_bond_type: "",
            deposit_bond_desc: "",
            recoupment: "",
            daily_penalty_rate: "",
            manage_penalty_rate: "",
            other_penalty: "",
            ot_penalty_rate: "",
            terminate_penalty: "",
            acquired_buyer: "",
            acquired_seller: "",
            warranty: "",
            other_special_clause: "",
            id_language: 0,
            share_pdpa: "",
            user_comment: "",
            id_confidential_level: 0,
        },
        validationSchema: Yup.object({
            project_name: Yup.string().required("กรุณาเลือก/Please select"),
        }),onSubmit: (values) => {
            console.log(values);
        }
    });

    const OnSetFileReqLegalTeamToDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileReqLegalTeamToDoc(fileName);
        validation.handleChange('req_legal_team_to_doc')(fileName);
    };

    const OnSetFileDetailProductDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileDetailProductDoc(fileName);
        validation.handleChange('detail_product_doc')(fileName);
    };

    const OnSetFileSaleDetailDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileSaleDetailDoc(fileName);
        validation.handleChange('sale_detail_doc')(fileName);
    };

    const OnSetFileCounterpartyDoc = (files) => {
        const fileName = (files.length > 0) ? files[0].name : "";
        setFileCounterpartyDoc(fileName);
        validation.handleChange('counterparty_doc')(fileName);
    };

    return (
        <React.Fragment>
            <div className="mx-auto">
                <Form className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        // validation.handleSubmit();
                        return false;
                    }}
                >
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ข้อมูลทั่วไป (Request General Information)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                <Input id="txtTypeOfRequest"
                                    type="text"
                                    name="typeOfRequest"
                                    value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">เรื่อง (Matters)</Label>
                                <Input id="txtTypeOfRequest"
                                    type="text"
                                    name="typeOfRequest"
                                    value={dataFormRequest.name_en_sub_request_type ? dataFormRequest.name_en_sub_request_type || "" : formTemp.name_en_sub_request_type || ""}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ชื่อโครงการ (Project Name)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prProjectName"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prProjectName" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtProjectName"
                                    name="project_name"
                                    placeholder="ระบุชื่อโครงการ(ถ้ามี)"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.project_name || ""}
                                    invalid={ validation.touched.project_name && validation.errors.project_name ? true : false }
                                />
                                { validation.touched.project_name && validation.errors.project_name ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.project_name}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ต้องการให้ฝ่ายกฎหมายดำเนินการ (Request Legal Team to)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prReqLegalTeamTo"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prReqLegalTeamTo" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlReqLegalTeamTo"
                                    name="req_legal_team_to"
                                    value={selectReqLegalTeamTo}
                                    className="txt-placeholder"
                                    placeholder="เลือกความต้องการในการดำเนินการ"
                                    onChange={(selected) => {
                                        setSelectReqLegalTeamTo(selected);
                                        validation.handleChange("req_legal_team_to")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlReqLegalTeamTo}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.req_legal_team_to && validation.errors.req_legal_team_to ? true : false }
                                />
                                { validation.touched.req_legal_team_to && validation.errors.req_legal_team_to ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.req_legal_team_to}
                                    </FormFeedback> 
                                ) : false }  
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Label className="label-title pb-2">เอกสารแนบเพื่อพิจารณา (Attachment)<span className="msg-require">*</span></Label>
                            <SingleUploadfile inputID="regLegalTeamToDoc" folder={dataFormRequest.request_no} dataFile={fileReqLegalTeamToDoc} setDataFile={OnSetFileReqLegalTeamToDoc} />
                            { validation.touched.req_legal_team_to_doc && validation.errors.req_legal_team_to_doc ?  ( 
                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                    {validation.errors.req_legal_team_to_doc}
                                </FormFeedback> 
                            ) : false }
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ชื่อคู่สัญญา (The Parties)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ทำหนังสือมอบอำนาจในนามของ (Company Name)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prBU"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prBU" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlIdBusinessUnit"
                                    name="id_business_unit"
                                    value={selectBU}
                                    className="txt-placeholder"
                                    placeholder="กรอก"
                                    onChange={(selected) => {
                                        setSelectBU(selected);
                                        validation.handleChange("id_business_unit")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlBU}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                />
                                { validation.touched.id_business_unit && validation.errors.id_business_unit ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_business_unit}
                                    </FormFeedback> 
                                ) : false }   
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">อื่นๆ (Others)<span className="msg-require">*</span></Label>
                                <Input id="txtBusinessUnitOther"
                                    name="business_unit_other"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.business_unit_other || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false }
                                />
                                {validation.touched.business_unit_other && validation.errors.business_unit_other ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.business_unit_other}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">โดยเป็นฝ่าย (Act as)<span className="msg-require">*</span></Label>
                                <Select id="ddlBusinessUnitActAs"
                                    name="business_unit_act_as"
                                    value={selectBuActAs}
                                    className="txt-placeholder"
                                    placeholder="เลือกฝ่ายการดำเนินการ"
                                    onChange={(selected) => {
                                        setSelectBuActAs(selected);
                                        validation.handleChange("business_unit_act_as")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlBU}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.business_unit_act_as && validation.errors.business_unit_act_as ? true : false }
                                />
                                { validation.touched.business_unit_act_as && validation.errors.business_unit_act_as ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.business_unit_act_as}
                                    </FormFeedback> 
                                ) : false }   
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ชื่อคู่สัญญาอีกฝ่าย (Counterparty's Name)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prCounterPartyName"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prCounterPartyName" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtCounterPartyName"
                                    name="counterparty_name"
                                    type="text"
                                    placeholder="ระบุชื่อคู่สัญญาอีกฝ่าย"
                                    className="txt-placeholder"
                                    value={validation.values.counterparty_name || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.counterparty_name && validation.errors.counterparty_name ? true : false }
                                />
                                {validation.touched.counterparty_name && validation.errors.counterparty_name ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.counterparty_name}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title pb-2">สำเนาเอกสารคู่สัญญา (Attachment)<span className="msg-require">*</span></Label>
                                <SingleUploadfile inputID="counterpartyDoc" folder={dataFormRequest.request_no} dataFile={fileCounterpartyDoc} setDataFile={OnSetFileCounterpartyDoc} />
                                { validation.touched.counterparty_doc && validation.errors.counterparty_doc ?  ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.counterparty_doc}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">โดยเป็นฝ่าย (Act as)<span className="msg-require">*</span></Label>
                                <Select id="ddlCounterpartyActAs"
                                    name="counterparty_act_as"
                                    value={selectCounterpartyActAs}
                                    className="txt-placeholder"
                                    placeholder="เลือกฝ่ายการดำเนินการ"
                                    onChange={(selected) => {
                                        setSelectCounterpartyActAs(selected);
                                        validation.handleChange("counterparty_act_as")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlBU}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.counterparty_act_as && validation.errors.counterparty_act_as ? true : false }
                                />
                                { validation.touched.counterparty_act_as && validation.errors.counterparty_act_as ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.counterparty_act_as}
                                    </FormFeedback>
                                ) : false }   
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                รายละเอียดการซื้อขาย (Sales Details)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">วัตถุประสงค์ของการซื้อขายและติดตั้ง (Purpose of Sales and installation)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPurposeSale"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPurposeSale" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtPurposeSale"
                                    name="purpose_sale"
                                    type="text"
                                    placeholder="ระบุวัตถุประสงค์ของการจ้างงาน"
                                    className="txt-placeholder"
                                    value={validation.values.purpose_sale || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.purpose_sale && validation.errors.purpose_sale ? true : false }
                                />
                                {validation.touched.purpose_sale && validation.errors.purpose_sale ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.purpose_sale}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">สถานที่ที่ส่งมอบและติดตั้งสินค้า (Place of delivery and installation)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPlaceOfDelivery"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPlaceOfDelivery" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtPlaceOfDelivery"
                                    name="place_of_delivery"
                                    type="text"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    className="txt-placeholder"
                                    value={validation.values.place_of_delivery || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.place_of_delivery && validation.errors.place_of_delivery ? true : false }
                                />
                                {validation.touched.place_of_delivery && validation.errors.place_of_delivery ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.place_of_delivery}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">รายการสินค้าที่ซื้อขาย (Details of products)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prDetailProduct"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prDetailProduct" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtDetailProduct"
                                    name="detail_product"
                                    type="text"
                                    placeholder="ระบุรายละเอียดของขอบเขตงานตามสัญญานี้"
                                    className="txt-placeholder"
                                    value={validation.values.detail_product || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.detail_product && validation.errors.detail_product ? true : false }
                                />
                                {validation.touched.detail_product && validation.errors.detail_product ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.detail_product}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title pb-3">แนบเอกสารหากไม่กรอกรายการซื้อขาย (Attachment)</Label>
                                <SingleUploadfile inputID="detailProductDoc" folder={dataFormRequest.request_no} dataFile={fileDetailProductDoc} setDataFile={OnSetFileDetailProductDoc} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ขอบเขต และรายละเอียดการส่งมอบสินค้าและติดตั้งสินค้า (Scope of Work of deliverables and installation)<span className="msg-require">*</span></Label>
                                <Input id="txtSowDeliver"
                                    name="sow_deliver"
                                    placeholder="กรอก"
                                    type="textarea"
                                    rows="5"
                                    className="from-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.sow_deliver || ""}
                                    invalid={ validation.touched.sow_deliver && validation.errors.sow_deliver ? true : false }
                                />
                                { validation.touched.sow_deliver && validation.errors.sow_deliver ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.sow_deliver}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Label className="label-title pb-3">เอกสารแนบเพื่อพิจารณา (Attachment)</Label>
                            <i className="mdi mdi-help-circle icon-hint" id="prSaleDetailDoc"></i>
                            <div className="hstack flex-wrap gap-2">
                                <UncontrolledPopover placement="right" target="prSaleDetailDoc" >
                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                </UncontrolledPopover>
                            </div>
                            <SingleUploadfile inputID="saleDetailDoc" folder={dataFormRequest.request_no} dataFile={fileSaleDetailDoc} setDataFile={OnSetFileSaleDetailDoc} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ระยะเวลาของสัญญา (Term)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">วันเริ่มต้น (Commencement Date)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prTermStartDate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prTermStartDate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtTermStartDate"
                                    name="term_start_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.term_start_date || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.term_start_date && validation.errors.term_start_date ? true : false }
                                />
                                { validation.touched.term_start_date && validation.errors.term_start_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.term_start_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">วันสิ้นสุดสัญญา (Expiry Date)</Label>
                                <Input id="txtTermEndDate"
                                    name="term_end_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.term_end_date || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.term_end_date && validation.errors.term_end_date ? true : false }
                                />
                                { validation.touched.term_end_date && validation.errors.term_end_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.term_end_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10} className="mb-2">
                            <Label className="label-title">วันส่งมอบสินค้า/งานติดตั้งแบบพร้อมใช้งาน (Certificate of Practical Completion)<span className="msg-require">*</span></Label>
                            <i className="mdi mdi-help-circle icon-hint" id="prPracticalCompleteDate"></i>
                            <div className="hstack flex-wrap gap-2">
                                <UncontrolledPopover placement="right" target="prPracticalCompleteDate" >
                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                </UncontrolledPopover>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ระบุวันที่ (Specific date/month/year)<span className="msg-require">*</span></Label>
                                <Input id="txtPracticalCompleteDate"
                                    name="practical_complete_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.practical_complete_date || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.practical_complete_date && validation.errors.practical_complete_date ? true : false }
                                />
                                { validation.touched.practical_complete_date && validation.errors.practical_complete_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.practical_complete_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <div className="form-check ms-4 pt-4">
                                    <Input id="cbPcMultiDateType"
                                        name="payment_term"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={pcMultiDateType === "1"}
                                        onChange={() => {
                                            setPcMultiDateType("1");
                                            validation.handleChange('pc_multi_date_type')("1");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbPcMultiDateType">
                                        ไม่มี (No CPC. Date)
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ระบุประเภทของงานที่ต้องส่งมอบในแต่ละงาน (Specify each work of such CPC.)</Label>
                                <Input id="txtPcMultiDateDetail"
                                    name="pc_multi_date_detail"
                                    type="text"
                                    placeholder="ระบุรายละเอียดของขอบเขตงานตามสัญญานี้"
                                    className="txt-placeholder"
                                    value={validation.values.pc_multi_date_detail || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.pc_multi_date_detail && validation.errors.pc_multi_date_detail ? true : false }
                                />
                                {validation.touched.pc_multi_date_detail && validation.errors.pc_multi_date_detail ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.pc_multi_date_detail}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">วันส่งมอบสินค้า/งานติดตั้งแบบเสร็จสมบูรณ์ (Certificate of Final Completion)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prFinalCompleteDate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prFinalCompleteDate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtFinalCompleteDate"
                                    name="final_complete_date"
                                    type="date"
                                    className="form-control"
                                    value={validation.values.final_complete_date || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.final_complete_date && validation.errors.final_complete_date ? true : false }
                                />
                                { validation.touched.final_complete_date && validation.errors.final_complete_date ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.final_complete_date}
                                    </FormFeedback>
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup> 
                                <Label className="label-title">ระบุประเภทของงานที่ต้องส่งมอบในแต่ละงาน (Specify each work of such CFC.)</Label>
                                <Input id="txtFinalCompleteDetail"
                                    name="final_complete_detail"
                                    type="text"
                                    placeholder="ระบุรายละเอียดของขอบเขตงานตามสัญญานี้"
                                    className="txt-placeholder"
                                    value={validation.values.final_complete_detail || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.final_complete_detail && validation.errors.final_complete_detail ? true : false }
                                />
                                {validation.touched.final_complete_detail && validation.errors.final_complete_detail ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.final_complete_detail}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ราคาสินค้า และค่าติดตั้ง
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าสินค้า (Product Price)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prProductPrice"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prProductPrice" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtProductPrice"
                                    name="product_price"
                                    type="text"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    className="txt-placeholder"
                                    value={validation.values.product_price || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.product_price && validation.errors.product_price ? true : false }
                                />
                                {validation.touched.product_price && validation.errors.product_price ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.product_price}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าติดตั้ง หรือค่าบริการ Installation Fee or Service Fee<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prInstallationFee"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prInstallationFee" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtInstallationFee"
                                    name="installation_fee"
                                    type="text"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    className="txt-placeholder"
                                    value={validation.values.installation_fee || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.installation_fee && validation.errors.installation_fee ? true : false }
                                />
                                {validation.touched.installation_fee && validation.errors.installation_fee ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.installation_fee}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    มูลค่ารวมของค่าสินค้าและค่าติดตั้งหรือค่าบริการข้างต้นนั้น VAT<span className="msg-require">*</span>
                                    <br/>
                                    (The total product price, service fee and installation fee above is)
                                </Label>
                                <i className="mdi mdi-help-circle icon-hint" id="prTotalProductPriceType"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prTotalProductPriceType" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <div className="form-check ms-4">
                                    <Input id="cbTotalProductPriceExcludesVat"
                                        name="payment_term"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={totalProductPriceType === "1"}
                                        onChange={() => {
                                            setTotalProductPriceType("1");
                                            validation.handleChange('total_product_price_type')("1");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbTotalProductPriceExcludesVat">
                                        ไม่รวม VAT
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            (Excludes VAT)
                                        </span>
                                    </Label>
                                </div>
                                <div className="form-check ms-4">
                                    <Input id="cbTotalProductPriceIncludesVat"
                                        name="payment_term"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={totalProductPriceType === "2"}
                                        onChange={() => {
                                            setTotalProductPriceType("2");
                                            validation.handleChange('total_product_price_type')("2");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbTotalProductPriceIncludesVat">
                                        รวม VAT
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            (Includes VAT)
                                        </span>
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    ระบุมูลค่า VAT ของค่าสินค้า ค่าติดตั้ง และค่าบริการ specify VAT amount of product price, 
                                    <br />
                                    installation and service fee<span className="msg-require">*</span>
                                </Label>
                                <Input id="txtInstallationFee"
                                    name="installation_fee"
                                    type="text"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    className="txt-placeholder"
                                    value={validation.values.installation_fee || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.installation_fee && validation.errors.installation_fee ? true : false }
                                />
                                {validation.touched.installation_fee && validation.errors.installation_fee ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.installation_fee}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">อากรแสตมป์ (Stamp Duty)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prIsStampDuty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prIsStampDuty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlIsStampDuty"
                                    name="is_stamp_duty"
                                    value={selectIsStampDuty}
                                    className="txt-placeholder"
                                    placeholder="มีอากรแสตมป์หรือไม่"
                                    onChange={(selected) => {
                                        setSelectIsStampDuty(selected);
                                        validation.handleChange("is_stamp_duty")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlIsStampDuty}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.is_stamp_duty && validation.errors.is_stamp_duty ? true : false }
                                />
                                { validation.touched.is_stamp_duty && validation.errors.is_stamp_duty ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.is_stamp_duty}
                                    </FormFeedback> 
                                ) : false }  
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ระบุผู้ชำระค่าอากรแสตมป์</Label>
                                <Input id="txtStampDutyPrice"
                                    name="stamp_duty_price"
                                    type="text"
                                    placeholder="โปรดระบุผู้ชำระ"
                                    className="txt-placeholder"
                                    value={validation.values.stamp_duty_price || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.stamp_duty_price && validation.errors.stamp_duty_price ? true : false }
                                />
                                {validation.touched.stamp_duty_price && validation.errors.stamp_duty_price ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.stamp_duty_price}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">เงื่อนไขการชำระเงิน (Payment Term)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint" id="prPaymentTermType"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPaymentTermType" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <div className="form-check ms-4">
                                    <Input id="cbPaymentTermLumpSum"
                                        name="payment_term_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={paymentTermType === "1"}
                                        onChange={() => {
                                            setPaymentTermType("1");
                                            validation.handleChange('payment_term_type')("1");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbPaymentTermLumpSum">
                                        ชำระครั้งเดียว
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Lumpsum (please provide date)
                                        </span>
                                    </Label>
                                </div>
                                <Label className="label-title">ระบุรายละเอียดการชำระเงิน</Label>
                                <Input id="txtPaymentTermDescLumpSum"
                                    name="payment_term_desc_lump_sum"
                                    type="text"
                                    placeholder="โปรดระบุเงื่อนไขการต่ออายุสัญญา"
                                    className="txt-placeholder"
                                    value={validation.values.payment_term_desc_lump_sum || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.payment_term_desc_lump_sum && validation.errors.payment_term_desc_lump_sum ? true : false }
                                />
                                <div className="form-check ms-4 pt-3">
                                    <Input id="cbPaymentTermInstalment"
                                        name="payment_term_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={paymentTermType === "2"}
                                        onChange={() => {
                                            setPaymentTermType("2");
                                            validation.handleChange('payment_term_type')("2");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbPaymentTermInstalment">
                                        รายงวด
                                        <br/>
                                        <span className="form-check-label-2row-detail">
                                            Instalments (please provide details)
                                        </span>
                                    </Label>
                                </div>
                                <Label className="label-title">ระบุรายละเอียดการชำระเงิน<span className="msg-require">*</span></Label>
                                <Input id="txtPaymentTermDescInstalment"
                                    name="payment_term_desc_instalment"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.payment_term_desc_instalment || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.payment_term_desc_instalment && validation.errors.payment_term_desc_instalment ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">เครดิตการชำระเงิน หรือระยะเวลาถึงกำหนดชำระเงิน (Credit Term)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prCreditTerm"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prCreditTerm" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtCreditTerm"
                                    name="credit_term"
                                    type="text"
                                    placeholder="ระบุสถานที่ปฏิบัติงานโดยละเอียด"
                                    className="txt-placeholder"
                                    value={validation.values.credit_term || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.credit_term && validation.errors.credit_term ? true : false }
                                />
                                {validation.touched.credit_term && validation.errors.credit_term ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.credit_term}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">เงินล่วงหน้า/มัดจำ (Advance Payment/Deposit)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prDepositType"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prDepositType" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlDepositType"
                                    name="deposit_type"
                                    value={selectDepositType}
                                    className="txt-placeholder"
                                    placeholder="เลือกตัวเลือก"
                                    onChange={(selected) => {
                                        setSelectDepositType(selected);
                                        validation.handleChange("deposit_type")((selected !== null) ? selected.value : "");

                                    }}
                                    options={ddlDepositType}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.deposit_type && validation.errors.deposit_type ? true : false }
                                />
                                { validation.touched.deposit_type && validation.errors.deposit_type ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.deposit_type}
                                    </FormFeedback> 
                                ) : false }  
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label className="label-title">ระบุ (Provide amount and time to pay)</Label>
                                <Input id="txtDepositDetail"
                                    name="deposit_detail"
                                    type="text"
                                    placeholder="โปรดระบุผู้ชำระ"
                                    className="txt-placeholder"
                                    value={validation.values.deposit_detail || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.deposit_detail && validation.errors.deposit_detail ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                หลักประกัน (Bond)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">หลักประกันการปฏิบัติตามสัญญา (Performance Bond)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prPerformanceBond"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prPerformanceBond" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtPerformanceBond"
                                    name="performance_bond"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.performance_bond || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.performance_bond && validation.errors.performance_bond ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">เงินประกันผลงาน (Retention)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prRetention"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prRetention" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRetention"
                                    name="retention"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.retention || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.retention && validation.errors.retention ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">การคืนเงินประกันผลงาน (Returning of Retention)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prReturnOfRetention"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prReturnOfRetention" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtReturnOfRetention"
                                    name="return_of_retention"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.return_of_retention || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.return_of_retention && validation.errors.return_of_retention ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title mb-3">หลักประกันการชำระเงินล่วงหน้า หรือเงินมัดจำ (Advance Payment Bond or Deposit Bond)</Label>
                                <i className="mdi mdi-help-circle icon-hint" id="prDepositBondType"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prDepositBondType" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <div className="form-check ms-4">
                                    <Input id="cbDepositBondTypeYes"
                                        name="deposit_bond_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={depositBondType === "1"}
                                        onChange={() => {
                                            setDepositBondType("1");
                                            validation.handleChange('deposit_bond_type')("1");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbDepositBondTypeYes">
                                        มี (Yes)
                                    </Label>
                                </div>
                                <Label className="label-title">โปรดระบุ (Please provide details)<span className="msg-require">*</span></Label>
                                <Input id="txtDepositBondDesc"
                                    name="deposit_bond_desc"
                                    type="text"
                                    placeholder="โปรดระบุรูปแบบหลักประกัน อัตรา และเงื่อนไขการคืนหลักประกัน"
                                    className="txt-placeholder"
                                    value={validation.values.deposit_bond_desc || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.deposit_bond_desc && validation.errors.deposit_bond_desc ? true : false }
                                />
                                { validation.touched.deposit_bond_desc && validation.errors.deposit_bond_desc ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.deposit_bond_desc}
                                    </FormFeedback> 
                                ) : false }  
                                <div className="form-check ms-4 pt-3">
                                    <Input id="cbDepositBondTypeNo"
                                        name="deposit_bond_type"
                                        className="form-check-input" 
                                        type="radio"
                                        checked={depositBondType === "0"}
                                        onChange={() => {
                                            setDepositBondType("0");
                                            validation.handleChange('deposit_bond_type')("0");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" for="cbDepositBondTypeNo">
                                        ไม่มี (No)
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">การคืนเงินเบิกล่วงหน้า (Recoupment)</Label>
                                <i className="mdi mdi-help-circle icon-hint" id="prRecoupment"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prRecoupment" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRecoupment"
                                    name="recoupment"
                                    type="text"
                                    placeholder="โปรดระบุรูปแบบหลักประกัน อัตรา และเงื่อนไขการคืนหลักประกัน"
                                    className="txt-placeholder"
                                    value={validation.values.recoupment || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.recoupment && validation.errors.recoupment ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                ค่าปรับ (Penalty)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าปรับรายวัน (Daily Penalty rate)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prDailyPenaltyRate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prDailyPenaltyRate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtDailyPenaltyRate"
                                    name="daily_penalty_rate"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.daily_penalty_rate || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.daily_penalty_rate && validation.errors.daily_penalty_rate ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าควบคุมงาน (Management Penalty rate)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prManagePenaltyRate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prManagePenaltyRate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtManagePenaltyRate"
                                    name="manage_penalty_rate"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.manage_penalty_rate || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.manage_penalty_rate && validation.errors.manage_penalty_rate ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าปรับอื่นๆ (Others)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prOtherPenalty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prOtherPenalty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtOtherPenalty"
                                    name="other_penalty"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.other_penalty || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.other_penalty && validation.errors.other_penalty ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ค่าปรับกรณีทำงานนอกเวลาทำการ (OT Penalty rate)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prOtPenaltyRate"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prOtPenaltyRate" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtOtPenaltyRate"
                                    name="ot_penalty_rate"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.ot_penalty_rate || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.ot_penalty_rate && validation.errors.ot_penalty_rate ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">การบอกเลิกสัญญา (Termination)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prTerminatePenalty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prTerminatePenalty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtTerminatePenalty"
                                    name="terminate_penalty"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.terminate_penalty || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.terminate_penalty && validation.errors.terminate_penalty ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                การประกันภัย
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ผู้ซื้อจัดหา (Acquired by Buyer)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prAcquiredBuyer"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prAcquiredBuyer" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtAcquiredBuyer"
                                    name="acquired_buyer"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.acquired_buyer || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.acquired_buyer && validation.errors.acquired_buyer ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ผู้ขายจัดหา  (Acquired by Seller)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prAcquiredSeller"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prAcquiredSeller" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtAcquiredSeller"
                                    name="acquired_seller"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.acquired_seller || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.acquired_seller && validation.errors.acquired_seller ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">การรับประกันผลงาน (Warranty)</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prWarranty"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prWarranty" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtWarranty"
                                    name="warranty"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.warranty || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.warranty && validation.errors.warranty ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ข้อตกลงพิเศษหรือเงื่อนไขอื่น ๆ (หากมี) (Other Special clause or Conditions)</Label>
                                <Input id="txtOtheSpecialClause"
                                    name="other_special_clause"
                                    type="text"
                                    placeholder="กรอก"
                                    className="txt-placeholder"
                                    value={validation.values.other_special_clause || ""}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={ validation.touched.other_special_clause && validation.errors.other_special_clause ? true : false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <span className="span-title">
                                อื่นๆ (Others)
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label className="label-title">ภาษา (Language)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prIdLanguage"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prIdLanguage">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> เลือกได้เพียง 1 ภาษา หากมากกว่า 1 ภาษา User ต้องทำการแปลเอง<br/>Available in a single language; users are responsible for translation if a bilingual document is needed.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlLanguage"
                                    name="id_language"
                                    value={selectLanguage}
                                    className="txt-placeholder"
                                    placeholder="เลือกภาษา"
                                    onChange={(selected) => {
                                        setSelectLanguage(selected);
                                        validation.handleChange("id_language")((selected !== null) ? selected.value : "");
                                    }}
                                    options={ddlLanguage}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_language && validation.errors.id_language ? true : false }
                                />
                                { validation.touched.id_language && validation.errors.id_language ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_language}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                        <Col md={7}>
                            <FormGroup>
                                <Label className="label-title-confidential">ระดับชั้นความลับ (Confidentiality Level)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prIdConfidentialLevel"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prIdConfidentialLevel">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> "ทั่วไป" หมายถึง สามารถเปิดเผยให้ฝ่ายกฎหมายและผู้ที่เกี่ยวข้องได้ <br/>"เป็นความลับ" หมายถึง เอกสารนี้จะเปิดเผยให้แก่ฝ่ายกฎหมายที่ถูกระบุชื่อ และฝ่ายกฎหมายระดับ Associate Director ขึ้นไปเท่านั้น​<br/>"General" means that this request will be shared with all legal team members and related persons. ​<br/> "Confidential" means that this request will be shared with the specified legal person and legal associate directors or higher level.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                
                                <Select id="ddlConfidential"
                                    name="id_confidential_level"
                                    value={selectConfidential}
                                    className="txt-placeholder"
                                    placeholder="เลือกระดับความลับของเอกสาร"
                                    onChange={(selected) => {
                                        setSelectConfidential(selected);
                                        validation.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                    }}
                                    options={ddlConfidential}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_confidential_level && validation.errors.id_confidential_level ? true : false }
                                />
                                { validation.touched.id_confidential_level && validation.errors.id_confidential_level ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                        {validation.errors.id_confidential_level}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    มีการเปิดเผย/ใช้/ประมวลผลข้อมูลส่วนบุคคลภายใต้เอกสารนี้หรือไม่ 
                                    <br />
                                    (Personal data will be disclosed/used/processed under this document)
                                    <span className="msg-require">*</span>
                                </Label>
                                <i className="mdi mdi-help-circle icon-hint" id="prPdpa"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prPdpa">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> "ทั่วไป" หมายถึง สามารถเปิดเผยให้ฝ่ายกฎหมายและผู้ที่เกี่ยวข้องได้ <br/>"เป็นความลับ" หมายถึง เอกสารนี้จะเปิดเผยให้แก่ฝ่ายกฎหมายที่ถูกระบุชื่อ และฝ่ายกฎหมายระดับ Associate Director ขึ้นไปเท่านั้น​<br/>"General" means that this request will be shared with all legal team members and related persons. ​<br/> "Confidential" means that this request will be shared with the specified legal person and legal associate directors or higher level.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <div className="form-check form-check-inline ms-3 mt-3">
                                    <Input id="cbPdpaYes"
                                        name="share_pdpa"
                                        className="form-check-input"
                                        type="radio"
                                        checked={sharePdpa === "1"}
                                        onChange={() => {
                                            setSharePdpa("1");
                                            validation.handleChange('share_pdpa')("1");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" htmlFor="cbPdpaYes">
                                        Yes (This request will be shared with PDPA team)
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline ms-3 mt-3">
                                    <Input id="cbPdpaNo"
                                        name="share_pdpa"
                                        className="form-check-input"
                                        type="radio"
                                        checked={sharePdpa === "0"}
                                        onChange={() => {
                                            setSharePdpa("0");
                                            validation.handleChange('share_pdpa')("0");
                                        }}
                                    />
                                    <Label className="form-check-label-2row" htmlFor="cbPdpaNo">
                                        No
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ความเห็นของ User (User's Comment)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prUserComment"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prUserComment" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดแนบไฟล์เอกสารต้นเรื่องที่ต้องการใช้เอกสารสำคัญของบริษัทไปประกอบ เพื่อให้ฝ่ายกฎหมายใช้พิจารณาการจัดเตรียมเอกสารให้เช่น แบบฟอร์มคำขอ,แบบฟอร์มหนังสือมอบอำนาจที่เป็นของหน่วยงาน เป็นต้น<br/>Please attach the documents that required the corporate documents, such as the application form, power of attorney form specific to the agency, etc., so that the Legal Team can review and prepare the required documents accordingly.​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtUserComment"
                                    name="user_comment"
                                    placeholder="ระบุว่ามีความเห็นเพิ่มเติมในเอกสาร/สัญญาดังกล่าวอย่างไร"
                                    type="text"
                                    className="from-control txt-placeholder"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.other_fee || ""}
                                    invalid={ validation.touched.user_comment && validation.errors.user_comment ? true : false }
                                />
                                { validation.touched.user_comment && validation.errors.user_comment ? ( 
                                    <FormFeedback type="invalid" style={{display: "block"}}>
                                        {validation.errors.user_comment}
                                    </FormFeedback> 
                                ) : false }
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (Legal team who has handled this work (if any))</Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prRequestHandledBy"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="prRequestHandledBy">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (ขั้นตอนนี้ไม่ใช่การกำหนดเลือกคนทำงาน ฝ่ายกฎหมายขอสงวนสิทธิ์ในการกำหนดคนทำงานนี้ต่อไป)<br/>This request will be sent to the e-mail address of the e-mail person. (This step is not to select workers. The Legal Department reserves the right to solely decide and assign people to do this work.)</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input id="txtRequestHandledBy" 
                                    name="require_handled_by"
                                    className="txt-placeholder"
                                    placeholder="กรุณาระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.require_handled_by || ""}
                                    invalid={validation.touched.require_handled_by && validation.errors.require_handled_by ? true : false}
                                />
                                {validation.touched.require_handled_by && validation.errors.require_handled_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.require_handled_by}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-2">
                            <span className="span-title">
                                User Approval Process
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <FormGroup>
                                <Label className="label-title">
                                    คำขอนี้จะได้รับการตรวจสอบและอนุมัติโดยใครในฝ่ายผู้ขอ ก่อนส่งต่อให้ฝ่ายกฎหมาย<span className="msg-require">*</span>
                                </Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="prApproval"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="prApproval" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุชื่อผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ <br/>(Please specify the approver's name. Kindly note that all requests must be approved by director or higher level in your function.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">(This request will be reviewed and approved by whom of your function before Legal team’s review)</Label>
                                <Input id="txtApproveRequestBy"
                                    name="approve_request_by"
                                    type="text"
                                    className="txt-placeholder"
                                    placeholder="กรอกชื่อผู้อนุมัติ"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.approve_request_by || ""}
                                    invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                                />
                                {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.approve_request_by}
                                    </FormFeedback>
                                ) : false}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Alert className="border-0 border-0 remark-content">
                                <i className="mdi mdi-alert icon-remark-color"></i><strong className="remark-color"> หมายเหตุ (Remark) </strong><br/>
                                <span className="span-remark">"User รับทราบว่าแบบฟอร์มนี้เป็นความลับและมีวัตถุประสงค์เพื่อใช้ภายในบริษัทในเครือ BTS Group เท่านั้น หากพนักงานเปิดเผยข้อมูลแบบฟอร์มให้แก่บุคคลภายนอก ถือว่าประพฤติผิดวินัยอย่างร้ายแรง"</span><br/>
                                <span className="span-remark">"Users are fully aware that this request form is strictly private and confidential for internal use within BTS Group's affiliates only. Any employee disclosing this request form to the third party is considered a serious misconduct."</span>
                            </Alert>
                        </Col>
                    </Row>
                </Form>
            </div>
        </React.Fragment>
    );
};

export default RequestFormPam;